import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {query} from '../../../../../../modules/react-query/index';
import SlideUp from '../../../../components/react-slide-up';

import './index.scss';

@query({
  quantity: 'qty',
  sliderMin: 'sliderMin',
  sliderMax: 'sliderMax',
  sortKey: 'sortKey',
  tdt: 'tdt',
  categ: 'categ',
  priceWithFees: 'priceWithFees',
  excl: 'excl',
  priceBucket: 'priceBucket',
  mapType: 'mapType',
  multiSectionSelect: 'multiSectionSelect',
})
class SlideUpResetButton extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      resetButtonIn: false,
    };
  }

  static contextTypes = {
    track: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.isButtonIn();
  }

  componentDidUpdate() {
    this.isButtonIn();
  }

  handleClick = (...args) => {
    const {resetButtonIn} = this.state;
    const {onReset} = this.props;
    this.setState({resetButtonIn: !resetButtonIn});
    onReset(...args);
  };

  isButtonIn() {
    const {
      quantity,
      sliderMin,
      sliderMax,
      sortKey,
      tdt,
      categ,
      priceWithFees = false,
      excl,
      mapType,
      multiSectionSelect,
      isPriceIncludeFeesPreselected = false,
    } = this.props;
    const {resetButtonIn} = this.state;
    const resetButtonInUpdate = !!(
      quantity ||
      sliderMin ||
      sliderMax ||
      sortKey ||
      tdt ||
      categ ||
      priceWithFees === !isPriceIncludeFeesPreselected ||
      excl ||
      mapType ||
      !multiSectionSelect
    );

    if (resetButtonInUpdate !== resetButtonIn) {
      this.setState({resetButtonIn: resetButtonInUpdate});
    }
  }

  render() {
    const {resetButtonIn} = this.state;

    return (
      <SlideUp isComponentIn={resetButtonIn} classname="popup">
        <div className="Resetbutton">
          <button className="Resetbutton__button" onClick={this.handleClick} type="button">
            <FormattedMessage defaultMessage="Reset Filters" id="ListingsFilter.resetFilters" />
          </button>
        </div>
      </SlideUp>
    );
  }
}

SlideUpResetButton.propTypes = {
  /** Reset filters function */
  onReset: PropTypes.func.isRequired,

  /** Number of tickets */
  quantity: PropTypes.number,

  /** Min price selected */
  sliderMin: PropTypes.number,

  /** Max price selected */
  sliderMax: PropTypes.number,

  /** Sorting value */
  sortKey: PropTypes.string,

  /** Delivery type */
  tdt: PropTypes.array,

  /** Categories list */
  categ: PropTypes.array,

  /** Is price shown with fees? */
  priceWithFees: PropTypes.bool,

  /** Excluded categories */
  excl: PropTypes.any,

  /** Type of map */
  mapType: PropTypes.string,

  /** If multi selection is enabled */
  multiSectionSelect: PropTypes.bool,

  /** If price is shown with fees by default */
  isPriceIncludeFeesPreselected: PropTypes.bool,
};

export default SlideUpResetButton;
